import {memo} from 'react';
import {IOption} from 'shared/services/api/quiz/Quiz';
import {DisplayMode} from '../../DisplayMode';
import {UniqueAnswerConfig} from './UniqueAnswerConfig';
import {UniqueAnswerPreview} from './UniqueAnswerPreview';

interface IUniqueAnswerProps {
  displayMode: DisplayMode;
  value: IOption[];
  onChange: (value: IOption[]) => void;
}
export const UniqueAnswer: React.FC<IUniqueAnswerProps> = memo(
  ({displayMode, value, onChange}) => {
    return (
      <>
        {displayMode === DisplayMode.config && (
          <UniqueAnswerConfig value={value} onChange={onChange} />
        )}
        {displayMode === DisplayMode.preview && (
          <UniqueAnswerPreview value={value} />
        )}
      </>
    );
  },
);
